import { notificationQueryKeys } from './notification-query-keys';

export const emailNotificationQueryKeys = {
  ...notificationQueryKeys,
  email: 'email',
  userId: 'user_id',
  provider: {
    status: 'provider_state',
    error: 'provider_error',
  },
};
